import React, { useState, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

import * as Styles from './Navigation.styles';

import { Links } from './Links';

const MobileTrigger = ({ openMenuFn }) => {
  return (
    <Styles.MobileTrigger onClick={openMenuFn}>
      <div />
    </Styles.MobileTrigger>
  );
};

const Navigation = ({ fakeLink }) => {
  const [isMobileVivisble, setMobileVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const setOffset = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    const watchScroll = () => {
      window.addEventListener('scroll', setOffset);
    };
    watchScroll();

    return () => {
      window.removeEventListener('scroll', setOffset);
    };
  }, []);

  return (
    <Styles.NavWrapper scroll={scrollY}>
      <Styles.Navigation>
        <Link to='/'>
          <StaticImage
            src='./../../images/ZONA_logo.svg'
            height={128}
            alt='Zona logotyp'
          />
        </Link>
        <DesktopMenu links={Links} fakeLink={fakeLink} />
        <MobileTrigger openMenuFn={() => setMobileVisible(true)} />
        {isMobileVivisble ? (
          <MobileMenu
            links={Links}
            closeMenuFn={() => setMobileVisible(false)}
          />
        ) : null}
      </Styles.Navigation>
    </Styles.NavWrapper>
  );
};

export default Navigation;
